import axios from "axios";
import store from "@/store";

const UNAUTHORIZED = 401;
const NOT_FOUND = 404;

export default function setup() {
    axios.interceptors.request.use(
        config => {
            const token = store.getters["auth/token"];
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        },
        error => {
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            const { status } = error.response;
            console.log(status);
            if (status === UNAUTHORIZED) {
                console.log("UNAUTHORIZED");
                // todo
            }
            if (status === NOT_FOUND) {
                console.log("NOT_FOUND");
                // todo
            }
            return Promise.reject(error);
        }
    );
}
